<script>
    export default {
        name: "ThePersonalInput",
        props: {
            name: String,
            value: String,
            placeholder: String,
            type: {
                type: String,
                default: "text",
            },
            error: {
                type: String,
                default: "",
            },
        },
        computed: {
            phoneMask() {
                const mask =
                    this.value[0] === "8" ? "8 (###) ###-##-##" : "+7 (###) ###-##-##";
                return this.name === "phone" ? mask : "";
            },
        },
    };
</script>

<template>
    <label class="the-personal-input">
        <input
            class="the-personal-input__field"
            :name="name"
            :type="type"
            v-maska="phoneMask"
            :class="{ 'input-error': error.length }"
            :value="value"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
        />
        <span class="the-personal-input__error" v-if="error.length">{{ error }}</span>
    </label>
</template>

<style lang="scss">
    .the-personal-input {
        display: block;
        width: 100%;
    }

    .the-personal-input__field {
        width: 100%;
        padding: 9px 15px;
        color: var(--input-text-color);
        font-size: 16px;
        font-weight: var(--input-text-weight);
        line-height: 20px;
        background-color: var(--input-background-color);
        border: var(--input-border-width) solid var(--input-border-color);
        border-radius: var(--input-border-radius);
        transition: border-color 0.2s ease-in;
        &:hover:not(.input-error),
        &:focus:not(.input-error) {
            border-color: var(--input-border-color--hover);
        }
        &:not(:placeholder-shown):not(.input-error) {
            border-color: var(--input-border-color--active);
            &:hover {
                border-color: var(--input-border-color--active);
            }
        }
        &.input-error {
            border-color: var(--input-text-color--error);
        }
        @include bp($bp-desktop-sm) {
            padding: 14px 15px;
        }
    }

    .the-personal-input__error {
        display: block;
        margin-top: 4px;
        padding-left: 12px;
        color: var(--input-text-color--error);
        font-size: 12px;
        line-height: 16px;
    }
</style>
